class TicketService {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  retrieveTicketById(ticketID) {
    return this.apiClient.get(`tickets/${ticketID}`);
  }

  searchForTicketsSlim({facilityID, searchTerm, cancelToken}) {
    return this.apiClient.get("ticketsearch", {
      cancelToken,
      params: {
        entityID: facilityID,
        searchTerm: searchTerm,
        searchType: "ticketSlim"
      },
    });
  }

  searchForTicketsSlimAtSharedFacilities({facilityID, searchTerm, cancelToken, sharedEntityIDs}) {
    return this.apiClient.get("ticketsearch/shared", {
      cancelToken,
      params: {
        entityID: facilityID,
        searchTerm: searchTerm,
        searchType: "ticketSlim",
        sharedEntityIDs: sharedEntityIDs
      },
      paramsSerializer: params => {
        const parts = [];
        Object.entries(params).forEach(([key, val]) => {
          if (Array.isArray(val)) {
            val.forEach(v => parts.push(`${key}=${encodeURIComponent(v)}`));
          } else if (val !== undefined) {
            parts.push(`${key}=${encodeURIComponent(val)}`);
          }
        });
        return parts.join('&');
      },
    });
  }

  searchForTicketsWithValidations({ facilityID, searchTerm, searchType, cancelToken }) {
    return this.apiClient.get("ticketsearch", {
      cancelToken,
      params: {
        entityID: facilityID,
        searchTerm: searchTerm,
        searchType: searchType
      },
    });
  }

  async updateTicket(ticket) {
    return await this.apiClient.put("tickets", ticket, {
      headers: { "Content-Type": "application/json" },
    });
  }

  async createTicket(ticket) {
    return await this.apiClient.post("tickets", ticket, {
      headers: { "Content-Type": "application/json" },
    });
  }

  async negotiateTicket(ticket) {
    return await this.apiClient.post("tickets/negotiate", ticket, {
      headers: { "Content-Type": "application/json" },
    });
  }

  async getTicket(ticketID, entityID) {
    return await this.apiClient.get(`tickets/${ticketID}?entityID=${entityID}`);
  }

  async getTicketAtSharedFacilities(ticketID, facilityIDs) {
    return await this.apiClient.get(`tickets/${ticketID}/shared`, {
      params: { facilityIDs },
      paramsSerializer: params => {
        const parts = [];
        Object.entries(params).forEach(([key, val]) => {
          if (Array.isArray(val)) {
            val.forEach(v => parts.push(`${key}=${encodeURIComponent(v)}`));
          } else if (val !== undefined) {
            parts.push(`${key}=${encodeURIComponent(val)}`);
          }
        });
        return parts.join('&');
      },
    });
  }

  async validateTicket(ticketID, entryTime) {
    return await this.apiClient.get(`tickets/${ticketID}/validate`, {
      params: { entryTime: entryTime },
    });
  }
  async updateOnePassStatus(ticketID, change) {
    return this.apiClient.patch(
      `onepass/${ticketID}/status`,
      { status: change.status, reason: change.reason },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  }
  async getTicketByLicensePlate(entityID, searchTerm) {
    return await this.apiClient.get(
      `ticketsearch/lpr/${entityID}`,
      {
        params: { searchTerm: searchTerm },
      });
  }
}
export default TicketService;
